import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';
import { Stack } from 'src/core/ui';
import { EventsTable } from 'src/tables/EventsTable/EventsTable';
import { EventsTableColumnId } from 'src/utils/columns/events/eventsColumnUtils.types';
import { EventWithData } from 'src/WebApiController';

import { header } from './EventsTableWithInnerGrouping.css';

interface EventsTableWithInnerGroupingProps {
  before?: ReactNode;
  topListItemBefore?: ReactNode;
  events: EventWithData[];
  columnSettingButton?: ReactNode;
  tableHeadStyle?: CSSProperties;
  highlightEvent?: string; // Event UUID
  scrollToEventVirtId?: string;
}

const posTableHeadStyle: CSSProperties = {
  position: 'sticky',
  top: '0',
};

export const EventsTableWithInnerGrouping = ({
  events,
  before,
  topListItemBefore,
  columnSettingButton,
  highlightEvent,
  scrollToEventVirtId,
}: EventsTableWithInnerGroupingProps) => {
  return (
    <Stack direction="column" height="full" width="full">
      <div>{before}</div>
      {topListItemBefore}
      <Stack
        justifyContent="end"
        alignItems="center"
        className={clsx(header)}
        gap="m"
      >
        {columnSettingButton}
      </Stack>
      <EventsTable
        events={events}
        failedToRetrieveData={false}
        useVirtuoso={true}
        usePagination={false}
        useDataGrouping={true}
        withOuterPadding={true}
        tableHeadStyle={posTableHeadStyle}
        highlightedId={highlightEvent}
        initState={{
          sorting: [
            {
              id: EventsTableColumnId.Date,
              desc: false,
            },
          ],
          grouping: [EventsTableColumnId.Date],
        }}
        scrollToEventVirtId={scrollToEventVirtId}
      />
    </Stack>
  );
};
